import { render, staticRenderFns } from "./NavBarAdmin.vue?vue&type=template&id=20d4a659&scoped=true"
import script from "./NavBarAdmin.vue?vue&type=script&lang=js"
export * from "./NavBarAdmin.vue?vue&type=script&lang=js"
import style0 from "./NavBarAdmin.vue?vue&type=style&index=0&id=20d4a659&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d4a659",
  null
  
)

export default component.exports